import { FormikProps } from "formik";

import { useAuth } from "@vahak/core/dist/components/auth/useAuth";
import { LoginScope } from "@vahak/core/dist/_services/sms.service";

import { LoginFormFieldsTypes } from "../../common/contant";

interface UseLoginAuthBindingsOptions {
    formik: FormikProps<LoginFormFieldsTypes>;
    phoneNum?: string | number;
    isInitiatedFrom: string;
    userJoiningBonusEnabled?: boolean;
}

/** Wires `useAuth` to the current Formik login form values. */
export function useLoginAuthBindings({
    formik,
    phoneNum,
    isInitiatedFrom,
    userJoiningBonusEnabled = false
}: UseLoginAuthBindingsOptions) {
    return useAuth({
        phoneNum: formik.values.phoneNumber || phoneNum,
        otp: Number(formik.values.otp),
        name: formik.values.companyName,
        serviceType: formik.values.serviceType,
        placeId: formik.values.currentPlaceID,
        whatsappUpdatesEnabled: formik.values.whatsappUpdatesEnabled,
        isInitiatedFrom,
        referralCode: formik.values.referralCode,
        otpScope: LoginScope.LOGIN,
        user_joining_bonus_enabled: userJoiningBonusEnabled
    });
}
